// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const TextBook = createSvgIcon(
  { LeftToRight: <React.Fragment><path stroke="currentColor" strokeWidth="2" d="M18.4262 1.0005H2.8333C1.8208 1.0005 1 1.8213 1 2.8338v18.333c0 1.0125.8208 1.8333 1.8333 1.8333H23V3.4449" /><path stroke="currentColor" strokeWidth="2" d="M23.9999 4H2.8589A1.5 1.5 0 011.384 2.7731v0C1.2133 1.851 1.9211 1 2.859 1h17.1407v2.4444M4 4v19" /><path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M8 19h11M8 8h11M8 12h11" /></React.Fragment>, },
  'default'
);
